<template>
  <div class="home">
    <Headerview/>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
    Headerview: () => import(/* webpackChunkName: 'header' */ "../components/header-view.vue")
  }
}
</script>
